import React, { useState } from 'react';
import AloModal from '../../../../../templates/_shared/ui-components/YogaUI/alo-ui/AloModal';
import { closeLoyaltyVariantSelectorModal, loyaltyState, openLoyaltyVariantSelectorModal } from './loyaltyState';
import { observer } from 'mobx-react-lite';
import { LLreward } from './loyaltyTypes';
import { claimReward } from './loyaltyUtils';
import AloDropdown from '../../../../../templates/_shared/ui-components/YogaUI/alo-ui/AloDropdown';

let RewardVariantSelector = ({ reward, buttonText }: { reward: LLreward; buttonText: string }) => {
  const [selectedVariant, setSelectedVariant] = useState(reward.target_products[0]!.variant_id.toString());
  const onModalCloseHandler = () => {
    closeLoyaltyVariantSelectorModal();
  };

  const handleOnClick = async () => {
    const response = await claimReward(reward.id, selectedVariant, reward.market);

    if (response?.success) {
      closeLoyaltyVariantSelectorModal(); // ? [REVISIT] Add UI feedback in case of fail
    }
  };

  const dropdownItems = reward.target_products.map((product) => {
    return { key: product.variant_id.toString(), text: product.title };
  });

  return (
    <AloModal
      wrapperClass={`reward-variant-selector`}
      disableBackdropClick={false}
      open={loyaltyState.isVariantSelectorModalOpen}
      showCloseButton={true}
      onClose={() => onModalCloseHandler()}
      onOpen={openLoyaltyVariantSelectorModal}
    >
      <div className="modal-content">
        <h4 className="title h4">{reward.title}</h4>
        <p className="modal-subtitle body-large semibold">{`Redeem ${reward.point_cost} points for this reward?`}</p>
        <p className="description body">We'll add this product to your cart for free and you can checkout as normal</p>
        <AloDropdown
          placeholder={''}
          wrapperClass="reward-variant-selector-dropdown"
          defaultValue={{
            key: selectedVariant,
            text: reward.target_products[0]?.title || 'Default Variant',
          }}
          dropdownItems={dropdownItems}
          onChange={({ key }) => {
            setSelectedVariant(key);
          }}
        />
        <div className="buttons">
          <button type="button" className="cancel-button button-ghost" onClick={closeLoyaltyVariantSelectorModal}>
            Not Now
          </button>
          <button type="button" className="action-button button-primary" onClick={handleOnClick}>
            {buttonText}
          </button>
        </div>
      </div>
    </AloModal>
  );
};

RewardVariantSelector = observer(RewardVariantSelector);
export { RewardVariantSelector };
